import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const List = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.2914 43.1239L14.3747 40.2072L17.083 37.4989C13.4372 37.2905 10.373 35.8843 7.89034 33.2801C5.4077 30.6759 4.16638 27.5683 4.16638 23.9572C4.16638 20.1725 5.47715 16.9693 8.09867 14.3478C10.7202 11.7263 13.9233 10.4155 17.708 10.4155H24.9997V14.5822H17.708C15.1039 14.5822 12.8903 15.485 11.0674 17.2905C9.24451 19.0961 8.33305 21.3009 8.33305 23.9051C8.33305 26.3704 9.1577 28.4884 10.807 30.2593C12.4563 32.0301 14.5136 33.0197 16.9789 33.228L14.3747 30.6239L17.2914 27.7072L24.9997 35.4155L17.2914 43.1239ZM29.1664 37.4989V33.3322H45.833V37.4989H29.1664ZM29.1664 26.0405V21.8739H45.833V26.0405H29.1664ZM29.1664 14.5822V10.4155H45.833V14.5822H29.1664Z"
        fill={color}
      />
    </svg>
  )
}
